'use strict';

var ajax = require('./ajax'),
	dialog = require('./dialog'),
	linchpin = require('int_googletagmanager/linchpin/giftcard'),
	linchpinError = require('int_googletagmanager/linchpin/error'),
	klarnaform = require('./pages/klarnaform');

/**
 * @function
 * @description initialize reloading the gift card area on billing page
 * 				if click on 'Check Balance' button
 * 				checks balance and reloads the gift card area to show gift card balance
 */
function initGiftCardCheckBalance() {
	var $giftCardCode = $('input[name$="_giftCertCode"]'),
		$giftCardPin = $('input[name$="_giftCertPin"]'),
		$sourcePage = $('input[name="sourcePage"]');

	$('#check-giftcert').on('click', function (e) {
		e.preventDefault();
		var $balance = $('.balance'),
			$giftCardErrors = $('#giftcards-area .billing-section-content .error'),
			gcHasExistingError = $giftCardErrors.length > 0;
		// Clean up errors
		if (gcHasExistingError) {
			$giftCardErrors.remove();
		}
		// Check gift card number
		if ($giftCardCode.length === 0 || $giftCardCode.val().length === 0) {
			var error = $balance.find('span.error');
			if (error.length === 0) {
				error = $('<span>').addClass('error').appendTo($balance);
			}
			error.html(Resources.GIFT_CARD_MISSING);
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpinError.formErrorEventSingle([$giftCardCode], error);
			}
			return;
		}
		// Check pin number
		if ($giftCardPin.length === 0 || $giftCardPin.val().length === 0) {
			var pinerror = $balance.find('span.error');
			if (pinerror.length === 0) {
				pinerror = $('<span>').addClass('error').appendTo($balance);
			}
			pinerror.html(Resources.GIFT_CARD_PIN_MISSING);
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpinError.formErrorEventSingle([$giftCardPin], pinerror);
			}
			return;
		}

		$(this).addClass('white').children('span:first').text(window.Resources.PLEASE_WAIT);

		ajax.load({
			url: Urls.giftCardCheckBalance,
			data: {giftCardNumber: $giftCardCode.val(), giftCardPin: $giftCardPin.val(), sourcePage: $sourcePage.val()},
			callback: function (response) {
				if ($sourcePage.val() === 'wallet') { // wallet in my accout
					try {
						var responseObject = JSON.parse(response);
						if (responseObject instanceof Object && responseObject.error !== '') {
							var gcerror = $balance.find('span.error');
							if (gcerror.length === 0) {
								gcerror = $('<span>').addClass('error').appendTo($balance);
							}
							if (responseObject.error === 'timeout') {
								gcerror.html(Resources.GIFT_CARD_TIMEOUT);
							} else {
								gcerror.html(Resources.GIFT_CARD_INVALID);
							}
							// GTM Linchpin analytics
							if (SitePreferences.GTM_ENABLED) {
								linchpinError.formErrorEventSingle([$giftCardCode, $giftCardPin], gcerror);
							}
						}
					} catch (exp) {
						window.console.error('Check balance exception', exp);
						$('#div-to-append-balance').after(response);
						// Change message
						$('.enter-giftcard-message').html(Resources.CHECK_ANOTHER_GIFT_CARD);
						// Clean form fields
						$giftCardCode.val('');
						$giftCardPin.val('');
					}
					// Change text on the button
					$('#check-giftcert').addClass('white').children('span:first').text(Resources.CHECK_BALANCE_BUTTON_TEXT);
				} else { // checkout billing
					$('#giftcards-area').html(response);
					initGiftCardAllocateAmount($giftCardCode.val(), $giftCardPin.val());
					initCancelGiftCardBalance();
					initGiftCardCheckBalance();
					initRemoveGCPaymentInstr();
					initAddGiftCardFields();
					// GTM Linchpin analytics
					if (SitePreferences.GTM_ENABLED) {
						linchpinError.formErrorEventSingle([$giftCardCode, $giftCardPin], $('#giftcards-area').find('.giftcert-error.error'));
					}
				}
			}
		});
	});

	updateBalanceToPay();
	handleGiftCardPaymentID();
}

/**
 * @function
 * @description initialize reloading the gift card area on billing page
 * 				if click on 'Allocate Amount' button
 * 				creates gift card PI and reloads the gift card area to render gift card PIs
 */
function initGiftCardAllocateAmount(code, pin) {
	$('#add-giftcert').on('click', function (e) {
		e.preventDefault();
		var amount = $('input[name$="_giftCertAmount"]').val();
		var buttonIdBeforeChange = e.target.id ? e.target.id : e.target.innerText;
		$(this).addClass('white').children('span:first').text(window.Resources.PLEASE_WAIT);
		ajax.load({
			url: Urls.redeemGiftCert,
			data: {giftCardNumber: code, giftCardPin: pin, giftCardAmount: amount},
			target: $('#giftcards-area'),
			callback: function () {
				initAddGiftCardFields();
				initRemoveGCPaymentInstr();
				updateBalanceToPay();
				handleGiftCardPaymentID();
				updateOrderTotalsOnBillingPage();
				reloadPageForSavedCards();
			}
		});
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.payGiftCodeEvent(buttonIdBeforeChange);
		}
	});
}
/**
 * @function
 * @description initialize reloading the gift card area on billing page
 * 				if click on 'Cancel' link
 * 				(cancel gift card balance, reloads the gift card area to show initial gift card input fields)
 */
function initCancelGiftCardBalance() {
	$('#cancel-gc-balance').on('click', function (e) {
		e.preventDefault();
		ajax.load({
			url: $(this).attr('href'),
			target: $('#giftcards-area'),
			callback: function () {
				initGiftCardCheckBalance();
				initAddGiftCardFields();
			}
		});
	});
}

/**
 * @function
 * @description Reload page to genarete new signature for saved cards
 */
function reloadPageForSavedCards() {
	if ($('.saved-cc-item').length) {
		window.location.reload();
	}
}

/**
 * @function
 * @description initialize reloading the gift card area on billing page
 * 				if click on 'Add Gift Card' button
 * 				(adds additional gift card fields for applying one more gift card)
 */
function initAddGiftCardFields() {
	$('#add-more-giftcert').on('click', function (e) {
		e.preventDefault();
		// hide add gift card button
		$('#add-gift-card-button-area').hide();
		// load gift card fields

		ajax.load({
			url: Urls.addGiftCardFields,
			target: $('#gc-fields-area'),
			callback: function () {
				// Remove server side error
				$('.giftcert-error').html('');
				initGiftCardCheckBalance();
				initRemoveGCFields();
			}
		});
	});
}

function updateOrderTotalsOnBillingPage() {
	$.ajax({
		url: Urls.orderTotalsRefreshURL
	}).done(function (response) {
		$('#orderTotalsSection').html(response);
		if ($('#klarna-form').length) {
			klarnaform.updateKlarnaPayments();
		}
	});
}

/**
 * @function
 * @description if click on 'Remove' it removed additional gift card input fields
 */
function initRemoveGCFields() {
	$('#remove-gc-fields').on('click', function () {
		// remove gift card fields
		$('#gc-fields-area').html('');
		// show add gift card button
		$('#add-gift-card-button-area').show();
		initAddGiftCardFields();
	});
}

/**
 * @function
 * @description initialize reloading the gift card area on billing page
 * 				if click on 'Remove' gift card payment instrument (PI)
 * 				(removes gift card PI and reloads the gift card area)
 */
function initRemoveGCPaymentInstr() {
	$('.remove-payment-instrument').on('click', function (e) {
		e.preventDefault();
		var url = $(this).attr('href');
		dialog.open({
			html: '<div>' + Resources.GIFTCARD_REMOVE_CONTENT + '</div>',
			options:{
				title: Resources.GIFTCARD_REMOVE_TITLE,
				dialogClass:'gift-card-popup remove',
				buttons: [
					{
						text: Resources.CANCEL,
						'class': 'gray',
						click:function () {
							$(this).dialog('close');
						}
					},
					{
						text: Resources.CONTINUE,
						'class': 'continue',
						click: function () {
							$(this).dialog('close');
							ajax.load({
								url: url,
								target: $('#giftcards-area'),
								callback: function () {
									initGiftCardCheckBalance();
									initAddGiftCardFields();
									initRemoveGCPaymentInstr();
									updateBalanceToPay();
									handleGiftCardPaymentID();
									updateOrderTotalsOnBillingPage();
								}
							});
						}
					}
				]
			}
		});
	});
	// If any gift cards have been redeemed, hide the paypal payment section.
	if ($('.amount-redeemed').length === 0) {
		$('#paypal-billing-form').show();
	} else {
		$('#paypal-billing-form').hide();
	}
}

/**
 * @function
 * @description update the balance to pay on the payment
 * methods using the gift card section
 */
function updateBalanceToPay() {
	var gcAmount = $('#giftcards-area').find('.gc-balance-to-pay .amount').text();
	var amount = $('#giftcards-area').find('.gc-balance-to-pay .amount').data('amount');
	if (!gcAmount || typeof amount === 'undefined') {
		return console.warn('no amount to pay included', amount);
	}

	$('.checkout-billing').find('.balance-to-pay .amount').each(function () {
		$(this).text(gcAmount);
	});

	if (!isNaN(amount) && amount >= 0) {

		// If any gift cards have been redeemed, hide the applepay payment section (if applepay session is active).
		var $applepayTab = $('#payment-tabs .tab-nav-applepay');
		if ($applepayTab.hasClass('active-session')) {
			if (amount > 0) {
				$applepayTab.removeClass('disabled');
			} else {
				$applepayTab.addClass('disabled');
			}
		}
		// Update umount for payment form
		var secureFormAmount = $('#secure-acceptance-form').find('[name="amount"]');
		if (secureFormAmount.length && secureFormAmount.val() !== amount) {
			secureFormAmount.val(amount);
		}
	}
	// If any gift cards have been redeemed, hide the paypal payment tab.
	if ($('.amount-redeemed').length === 0) {
		$('.tab-nav-paypal').removeClass('disabled');
	} else {
		$('.tab-nav-paypal').addClass('disabled');
	}
}

/**
 * @function
 * @description enable/disable gift card payment method ID basing on visibility of gift card Continue button
 */
function handleGiftCardPaymentID() {
	var $giftCardPaymentID = $('#payment-id-gift-card');
	var isGiftCardPayment = $('button.gift-card-submit').length > 0;
	$giftCardPaymentID.prop('disabled', !isGiftCardPayment);
	var $savedCCPaymentID = $giftCardPaymentID.closest('form').find('#selectedPaymentMethodID');
	$savedCCPaymentID.prop('disabled', isGiftCardPayment);
}

exports.initGiftCardCheckBalance = initGiftCardCheckBalance;
exports.initRemoveGCPaymentInstr = initRemoveGCPaymentInstr;
exports.initAddGiftCardFields = initAddGiftCardFields;
